import { computed, Ref } from "@vue/composition-api";
import { format, parseISO } from "date-fns";
import { isCallMessageDetails } from "@scrile/api-provider/dist/api/CallsProvider";
import { Message } from "@scrile/api-provider/dist/projects/scrileConnect/MessagesProvider";
import useAuthUser from "@/hooks/useAuthUser";

export default function useMessageView(message: Ref<Message>) {
  const { authUserStrict } = useAuthUser();
  const isOpponentMessage = computed(() => {
    if (isCallMessageDetails(message.value.details)) {
      return message.value.details.callerId !== Number(authUserStrict.value.id);
    }
    if (message.value.senderId === "0" && message.value.senderUser) {
      return message.value.senderUser.id !== authUserStrict.value.id;
    }
    return message.value.senderId !== authUserStrict.value.id;
  });
  const isAuthor = computed(() => !isOpponentMessage.value);
  const hoursMinutes = computed(() => format(parseISO(message.value.time), "hh:mm aaa"));
  const fullTime = computed(() => format(parseISO(message.value.time), "yyyy-MM-dd'T'hh:mm:ssxxx"));

  return { isOpponentMessage, isAuthor, hoursMinutes, fullTime };
}
